module.exports = __webpack_public_path__ + "static/scale-model-of-visit-fargo-moorhead-in-fargo-north-dakota-578276c30078f2edd9a78f07f31b3803.png";